import React, { useState, useEffect } from "react";
import { Col, Row, Table, Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import {
  dateFormat,
  formatDate,
  getTodayDateISO,
  numberFormat,
  refreshPage,
  toastStyle,
} from "../../../Helpers/Utils/Common";
import Navbar from "../../../Components/Navbar/Navbar";
import Moment from "moment";
import TablePagination from "../../../Components/TableTemplate/Table";
import CashAdvanceModal from "./CashAdvanceModal";
import {
  getCashAdvance,
  getCashAdvancePayment,
  updateCashAdvanceStatus,
} from "./../../../Helpers/apiCalls/Employees/CashAdvanceApi";
import Footer from "../../../Components/Footer/Footer";

function ReviewCashAdvance() {
  //variables
  const { id, type, ca_type } = useParams();
  let navigate = useNavigate();
  const [inactive, setInactive] = useState(true);
  const [paymentInfo, setPaymentInfo] = useState([]);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const handleShowApprovalModal = () => {
    setShowApprovalModal(true);
  };
  const handleCloseApprovalModal = () => setShowApprovalModal(false);
  /* approve modal handler */
  const [showDisapproveModal, setShowDisapproveModal] = useState(false);
  const handleShowDisapproveModal = () => {
    setShowDisapproveModal(true);
  };
  const handleCloseDisapproveModal = () => setShowDisapproveModal(false);
  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false);
  const handleShowPrintModal = () => setShowPrintModal(true);
  const handleClosePrintModal = () => setShowPrintModal(false);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [addDetails, setAddDetails] = useState({
    employee_id: "",
    date: "",
    // billing_start_month: "",
    amount: "",
    terms: "",
    purpose: "",
    subtotal: 0,
    other_fees: 0,
    grand_total: 0,
  });

  // FUNCTIONS
  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print(printContents);
    document.body.innerHTML = originalContents;
    refreshPage();
  }

  function renderTable() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th className="text-start">Name</th>
            <th className="text-end">Amount</th>
            <th className="text-end">Balance</th>
            <th className="text-end">DISBURSEMENT METHOD</th>
            <th className="text-end">TYPE</th>
            <th className="text-end">PAYABLE PER PAYROLL</th>
            <th className="text-start">FULL PMT DATE</th>
          </tr>
        </thead>
        <tbody>
          {employeeDetails.map((employee, index) => {
            return (
              <tr>
                <td className="franchise-td-gray text-start">
                  {employee.employee_name}
                </td>
                <td className="franchise-td-gray text-end">
                  {numberFormat(employee.amount)}
                </td>
                <td className="franchise-td-gray text-end">
                  {employee.balance ? numberFormat(employee.balance) : ""}
                </td>
                <td className="franchise-td-gray text-end">
                  {employee.disbursement_method}
                </td>
                <td className="franchise-td-gray text-end">
                  {employee.type.split("_")[0] +
                    " " +
                    employee.type.split("_")[1]}
                </td>
                <td className="franchise-td-gray text-end">
                  {employee.amount_payable_per_payroll ? numberFormat(employee.amount_payable_per_payroll) : ""}
                </td>
                <td className="franchise-td-gray text-start">
                  {dateFormat(employee.full_payment_date)}
                </td>
              </tr>
            );
          })}
          {/* <tr>
                        <td colSpan={4}></td>
                        <td
                            align="center"
                            className="print-table-footer-label grand-label"
                        >
                            GRAND TOTAL
                        </td>
                        <td
                            align="center"
                            className="franchise-td-gray"
                        >
                            {numberFormat(addDetails.grand_total)}
                        </td>
                    </tr> */}
        </tbody>
      </Table>
    );
  }

  //API
  async function handlePrintPI() {
    toast.loading("Printing Transfer Details", { style: toastStyle() });
    handleClosePrintModal();
    setTimeout(() => {
      toast.dismiss();
      Print();
    }, 1000);
  }

  async function handleApproveCashAdvance(type) {
    const response = await updateCashAdvanceStatus(id, "approved");

    if (response.error) {
      toast.error(response.error.response.data.messages.error, {
        style: toastStyle(),
      });
    } else {
      toast.success("Successfully Approved Cash Advance!", {
        style: toastStyle(),
      });
      setTimeout(() => {
        // handlePrintPI()
        navigate(-1);
      }, 1000);
    }
  }

  async function handleDisapproveCashAdvance(type) {
    const response = await updateCashAdvanceStatus(id, "disapproved");

    if (response.error) {
      toast.error(response.error.response.data.messages.error, {
        style: toastStyle(),
      });
    } else {
      toast.success("Successfully Disapproved Cash Advance!", {
        style: toastStyle(),
      });
      setTimeout(() => {
        // handlePrintPI()
        navigate(-1);
      }, 1000);
    }
  }

  async function fetchData() {
    setAddDetails([]);
    var data = {};
    if (type === "individual") {
      data.cash_advance_id = id;

      const response = await getCashAdvancePayment(data);

      if (response.error) {
        // TokenExpiry(response);
      } else {
        var allPayments = response.data.data.map((payment) => {
          var info = payment;
          info.paid_on = Moment(payment.paid_on).format("MM/DD/YYYY");
          // info.details = payment.payment_mode === "check" ? payment.payment_mode + " - " + payment.check_no
          //     : payment.payment_mode === "bank" ? payment.payment_mode + " - " + payment.reference_no
          //     : payment.payment_mode
          info.amount = payment.paid_amount
            ? numberFormat(payment.paid_amount)
            : "0.00";
          info.balance = payment.balance
            ? numberFormat(payment.balance)
            : "0.00";
          return info;
        });
        setPaymentInfo(allPayments);
      }
    } else {
      data.entry_id = id;
    }
    const response = await getCashAdvance(data);

    if (response.error) {
      // TokenExpiry(response);
    } else {
      var data = response.data.data.map((data) => {
        var info = data;
        info.grand_total = response.data.grand_total;
        info.employee_id_value = {
          value: data.employee_id,
          label: data.employee_name,
        };
        info.cash_advance_date = data.date;
        return info;
      });
      setAddDetails(data[0]);
      setEmployeeDetails(data[0].employees);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"PAYROLL"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* header */}
        <Row className="mb-4">
          <Col xs={12} lg={8}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
                REVIEW{" "}
              {ca_type?.split("_")[0].toUpperCase() +
                " " +
                ca_type?.split("_")[1].toUpperCase()}
              </h1>
          </Col>
          <Col xs={12} lg={4}>
              <span className="PI-header2">CASH ADVANCE ENTRY ID {id}</span>
          </Col>
        </Row>

        {/* content */}
        <div className="edit-form">
          <>
            <Row className="review-container py-3">
              <Row>
                <Col>
                  <span className="review-label nc-modal-custom-row">
                    Request Date
                  </span>
                </Col>
                <Col>
                  <span className="review-label nc-modal-custom-row">
                    Disbursement Date
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <span className="review-data">
                    {dateFormat(addDetails.avail_date)}
                  </span>
                </Col>
                <Col>
                  <span className="review-data">
                    {dateFormat(addDetails.disbursement_date)}
                  </span>
                </Col>
              </Row>
            </Row>
          </>

          <Row className="nc-modal-custom-row">
            <Col>EMPLOYEES</Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
            <div className="edit-purchased-items">
              {employeeDetails.length === 0 ? (
                <span>No Employee Found!</span>
              ) : (
                renderTable()
              )}
            </div>
            </Col>
          </Row>
          <Row className="align-right py-5 me-2">
            <Col xs={7} className="text-end">
              <span className="edit-label color-gray grand-total-text">
                Grand Total
              </span>
            </Col>
            <Col xs={2} className="text-end">
              <span className="edit-label align-middle grand-total-text">
                PHP
              </span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle grand-total-text">
                {numberFormat(addDetails.grand_total)}
              </span>
            </Col>
          </Row>

          {/* FOOTER: CANCEL & SUBMIT BUTTONS */}
          {type === "for_approval" && (
            <>
            <div className="d-flex justify-content-end pt-5">
              <button
                type="button"
                className="button-primary me-1"
                onClick={() => navigate("/cashadvance")}
              >
                Close
              </button>
              <button
                type="button"
                className="button-tertiary"
                onClick={() => navigate("/cashadvance/edit/" + id + "/" + type)}
              >
                Edit
              </button>
            </div>
            <div className="d-flex justify-content-end pt-2">
            <button
              type="button"
              className="button-warning me-1"
              onClick={() => handleShowDisapproveModal()}
            >
              Disapprove
            </button>
            <button
              type="button"
              className="button-primary"
              onClick={() => handleShowApprovalModal()}
            >
              Approve
            </button>
          </div>
          </>
          )}
          {type !== "for_approval" && (
            <div className="d-flex justify-content-end pt-5">
              <button
                type="button"
                className="button-primary me-3"
                onClick={handleShowPrintModal}
              >
                Print
              </button>
              <button
                type="button"
                className="button-secondary me-3"
                onClick={() => navigate("/cashadvance")}
              >
                Close
              </button>
            </div>
          )}
        </div>
        <Container
          fluid
          className="PI-payment-info-wrapper mt-5 py-3 px-3 edit-form"
        >
          <h5 className="PI-payment-info">PAYMENT HISTORY</h5>
          <div className="justify-content-center">
            <TablePagination
              tableHeaders={[
                "PAYROLL DATE",
                "PAID AMOUNT",
                // "REMAINING BALANCE",
                "ENCODED BY",
              ]}
              headerSelector={[
                "paid_on",
                "amount",
                // "balance",
                "added_by_name",
              ]}
              tableData={paymentInfo}
            />
          </div>
        </Container>
      </div>
      <CashAdvanceModal
        show={showPrintModal}
        hide={handleClosePrintModal}
        text="print this cash advance"
        page="transaction"
        handler={handlePrintPI}
      />

      <CashAdvanceModal
        show={showApprovalModal}
        hide={handleCloseApprovalModal}
        text="approve this cash advance"
        page="transaction"
        handler={handleApproveCashAdvance}
      />

      <CashAdvanceModal
        show={showDisapproveModal}
        hide={handleCloseDisapproveModal}
        text="disapprove this cash advance"
        type="disapprove"
        page="transaction"
        handler={handleDisapproveCashAdvance}
      />

      {/* PRINT VIEW */}
      <div className="print-container px-3 py-2 display-none" id="printablediv">
        <div className="text-end print-header d-flex flex-column">
          <span>CASH ADVANCE NO. {id}</span>
          <span className="text-uppercase">
            {Moment(addDetails.date).format("MMMM DD, yyyy")}
          </span>
        </div>
        {/* <div className="d-flex justify-content-center py-1">
                    <img src={cleanLogo} className="print-logo" />
                </div> */}
        <div className="d-flex justify-content-center py-1 ">
          <h5 className="print-header">CASH ADVANCE</h5>
        </div>
        <div className="d-flex justify-content-center py-1 mt-1">
          <h5 className="print-shop-header">
            TRIPLE K EXPRESSFOODS / 3K EXPRESSFOODS / CHK BUSINESS VENTURES CORP
          </h5>
        </div>

        <div className="print-body mt-5">
          <>
            <Row className="review-container py-3">
              <Col>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Request Date:
                  </Col>
                  <Col xs={7} className="print-data">
                    {dateFormat(addDetails.avail_date)}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Disbursement Date:
                  </Col>
                  <Col xs={7} className="print-data">
                    {dateFormat(addDetails.disbursement_date)}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Remarks:
                  </Col>
                  <Col xs={7} className="print-data">
                    {addDetails.remarks}
                  </Col>
                </div>
              </Col>
            </Row>
          </>

          <div className="mt-4 d-flex flex-column">
            <div className="review-purchased-items">{renderTable()}</div>
          </div>
          <div className="print-signatures">
            <span className="text-center text-uppercase print-label"> </span>
            <span className="text-center text-uppercase print-label fw-bold">
              {addDetails.prepared_by}
            </span>
          </div>
          <div className="print-signatories pb-4 mb-4">
            <span>Approved by</span>
            <span>Prepared by</span>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default ReviewCashAdvance;
